
























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import calculate from '@/common/util/calculate';
import { calendarPanel,NumberKeyboard } from "@/components";
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { TbOrderPad,TbGoods } from '@/http';
dayjs.locale('zh-cn')
@Component({
    components: {
        calendarPanel,NumberKeyboard
    },
})
export default class changeOrder extends Vue {
    public $refs: {
        barcode:HTMLFormElement;
    };
    fmoney = fmoney;

    /**查询项 */
    searchValue={
        goods:"",
        key:"",
        type:null,
        start:"",
        end:"",
        name:"",
        skip:0,
        count:20,
    }

    /**时间控件 */
    pickerShow = false;
    startDate="";
    endDate="";

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

    timeActive=null;

    userInfo:any={};

    defaultDate = [];

    @Watch('searchValue.goods')
    goodsChange(){
        this.getList();
    }
    
    
    created() {
    }
    
    async mounted() {
       
        console.log('defaultDate',this.defaultDate);
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));

            this.getInputFocus()
        document.addEventListener('click',this.chargeInputFocus)
       
    }
    getInputFocus(){
        this.$nextTick(()=>{
            this.$refs['barcode'].select()
            document.addEventListener('keydown', this.handleScanCode)
        })
    }

    async scanInput(val){
        let res = await TbGoods.GetTbGoodsByBarCode({barCode:val});
        if(res.getGoodsItemsList&&res.getGoodsItemsList.length>0){
            this.searchValue.goods = res.barCode?res.barCode:'';
        }
    }

    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input'&&event.target.tagName.toLowerCase() != 'textarea') {
            this.getInputFocus()
        }
    }
    beforeDestroy() {
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.removeEventListener('click', this.chargeInputFocus)
    }
    public scanCodes:any = ''
   /**
     * 监听扫码枪输入
     */
    async handleScanCode(event) {
        if (event.key === 'Backspace' || event.keyCode === 8) {
        // 允许退格键的默认行为
        return;
        }
        if(this.isFocus){
            this.searchValue.goods = event.target.value

        }
        if (event.key === 'Enter' || event.keyCode == 13) {
            console.log('换货扫码',event.target.value)
            let code = this.scanCodes?this.scanCodes:event.target.value
            await this.scanInput(code)
            this.scanCodes = ''
        return
        }
    }
    isFocus = false
    getFocus(){
        this.isFocus = true
    }
    inputBlur(){
        this.isFocus = false
        document.addEventListener('click',this.chargeInputFocus)
    }
    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            

            let s = this.searchValue.count;
            let res = await TbOrderPad.GetOrderList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId,
                orderStatus:2
            }))
            this.list = this.searchValue.skip==0? res.items:this.list.concat(res.items);
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            if (this.list.length >= this.total) {
            this.finished = true;
            
            }
    }

    async getList(){
        // this.onRefresh();
         // 清空列表数据
      this.finished = false;
        this.list = [];
        this.searchValue.skip=0;
        this.searchValue.count=20;
        this.total = 0;
        this.currentPage = 1;

        let res = await TbOrderPad.GetOrderList(Object.assign({},this.searchValue,{
            shopId:this.userInfo.shopId,
            orderStatus:2
        }))
        this.list = res.items;
        this.total  = res.totalCount;

    }

    openselDate() {
        if(this.startDate&&this.endDate){
            let start = new Date(this.startDate);
            let end = new Date(this.endDate);
            let defaultDate = [start,end];
            this.defaultDate = defaultDate;
        }else{
            let start = new Date();
            let end = new Date();
            let defaultDate = [start,end];
            this.defaultDate = defaultDate;
        }
        
        this.pickerShow = true;
    }
    /**确定选择时间 */
    onselConfirm(date){
        const [start, end] = date;
        this.startDate = dayjs(start).format("YYYY-MM-DD");
        this.endDate = dayjs(end).format("YYYY-MM-DD");
        this.searchValue.type = 6;
        this.pickerShow = false;
        this.timeActive = null;
        this.setTimeSearch();
        document.addEventListener('click',this.chargeInputFocus)

    }
    closeTime(){
        this.pickerShow = false;
    }
    async chooseTime(type){
        this.timeActive = type;
        // 获取当前日期
        const today = dayjs();
        const firstDayOfWeek = dayjs().startOf('week');
        const firstDayOfMonth = dayjs().startOf('month');
        const prevMonthStart = today.subtract(1, 'month').startOf('month');  
        const prevMonthEnd = today.subtract(1, 'month').endOf('month')
        this.searchValue.type = 6;
        switch (type) {
            case 1:
                this.startDate = today.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                // this.searchValue.type = 1;
                break;
            case 2:
                this.startDate = firstDayOfWeek.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                // this.searchValue.type = 3;
                break;
            case 3:
                this.startDate = firstDayOfMonth.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                // this.searchValue.type = 4;
                break;
            case 4:
                this.startDate = prevMonthStart.format("YYYY-MM-DD");
                this.endDate = prevMonthEnd.format("YYYY-MM-DD");
                // this.searchValue.type = 6;
                break;
        
            default:
                break;
            }
       
        
        await this.setTimeSearch();
    }
    async setTimeSearch(){
        this.searchValue.start=this.startDate+" 00:00:00";
        this.searchValue.end=this.endDate+" 23:59:59";
        await this.getList();
    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            goods:"",
            key:"",
            type:null,
            start:"",
            end:"",
            name:"",
            skip:0,
            count:20,
        }
        this.timeActive=null;
        this.startDate = "";
        this.endDate = "";
        this.getList();
    }
    finishPhone(val){
        this.searchValue.key = val;
        this.getList();
    }

    viewDetail(id){
        this.$router.push(`/pad/cashier/changeOrderDetail?id=${id}`);
    }

    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/changeOrder.vue